import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import EmployerHeaderScreen from "../../component/layout/employerheader";
import EmployerSidebarScreen from "../../component/layout/employer-sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import { LuEye } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import { SlBriefcase } from "react-icons/sl";
import { RiCalendarScheduleLine } from "react-icons/ri";

import { BsHourglassSplit } from "react-icons/bs";
import { Alert } from "../../common/Alert/alert";
import { employeerDashboard } from "../../service/apis/dashboard.api";
import { EmployeerDashboard } from "../../config/EmployeerDashboard";
import moment from "moment";
import DataTable from "../../common/data-table";
import { AppRoute } from "../../router/routerConstants";
import { useCustomNavigate } from "../../hooks/useCustomNavigate";
import { DeleteJobApi, viewJobApi } from "../../service/apis/employer.api";
import Loader from "../../common/Loader/loader";
import MessageList from "../jobseeker/common/message-list";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import { showError, showSuccess } from "../../utils/Common";

const EMPDashboardScreen = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const [isLoading, setIsLoading] = useState(false);
  const [dashboardDetails, setDashboardDetails] =
    useState<EmployeerDashboard | null>();

  const [recentPostJobsTableData, setRecentPostJobsTableData] = useState([]);
  const [NavigateTo] = useCustomNavigate();
  const [selectedJob, setSelectedJob] = useState<any>(null);

  const { messageList, chatHistory } = useSelector(
    (state: RootState) => state.chatSlice
  );
  const { user } = useSelector((state: RootState) => state.authSlice);
  const columns = [
    { label: "Jobs", key: "jobs" },
    { label: "Applicants", key: "applicants" },
    { label: "Shortlisted", key: "shortlisted" },
    { label: "Rejected", key: "rejected" },
    { label: "Hired", key: "hired" },
    { label: "View Applicant", key: "view_applicant" },
    { label: "Actions", key: "actions" },
  ];

  const getDashboard = async () => {
    try {
      setIsLoading(true);
      const response = await employeerDashboard();
      setDashboardDetails(response?.data);
      const transformed = await transformedData(response?.data?.resentJobs);
      setRecentPostJobsTableData(transformed);
    } catch (error: any) {
      showError(error?.message);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getDashboard();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const transformedData = async (applicants: any = []) => {
    return (
      applicants &&
      applicants?.map((app: any, index: number) => ({
        jobs: (
          <>
            <div className="profileholdertable d-flex">
              <h4>{app?.title || "N/A"}</h4>
            </div>
            <div>
              <p>
                Created on :{" "}
                {app?.createdAt
                  ? moment(app?.createdAt).format("DD MMM YYYY")
                  : "N/A"}
              </p>
              <p>
                Expires on :{" "}
                {app?.deadlineDate
                  ? moment(app?.deadlineDate).format("DD MMM YYYY")
                  : "N/A"}
              </p>
            </div>
          </>
        ),

        applicants: app?.applicationsSummary?.applied || 0,
        shortlisted: app?.applicationsSummary?.shortlisted || 0,
        rejected: app?.applicationsSummary?.rejected || 0,
        hired: app?.applicationsSummary?.hired || 0,
        view_applicant: (
          <div>
            <button
              className={"btn moreview "+(app?.applicationsSummary?.applied>0?``:`disabled`)}
              onClick={() => app?.applicationsSummary?.applied > 0 && handleView(app)}
              style={app?.applicationsSummary?.applied>0 ? { cursor: "pointer" }:undefined}
            >
              View Applicates
            </button>
          </div>
        ),
        actions: (
          <div>
            <button
              className="btnnoStyle btn btn-primary"
              onClick={() => handleViewJob(app?._id)}
              style={{ marginRight: "10px" }}
            >
              <LuEye />
            </button>
            <button
              className="btnnoStyle red btn btn-primary"
              onClick={() => handleDelete(app?._id)}
              style={{ marginRight: "10px" }}
            >
              <AiOutlineDelete />
            </button>
          </div>
        ),
      }))
    );
  };

  const handleView = async (row: any) => {
    NavigateTo(AppRoute.EMPLOYER_APPLICANTS, false, { jobId: row?._id });
  };

  // View job
  const handleViewJob = async (jobId: any) => {
    setIsLoading(true);
    try {
      const data = await viewJobApi(jobId);
      // console.log(data);
      setSelectedJob(data);
      setShow(true); // Open modal
    } catch (error) {
      console.error("Error fetching job details:", error);
    } finally {
      setIsLoading(false);
    }
  };
  //View job ends

  const handleDelete = async (jobId: any) => {
    Alert.confirm(
      "Delete Job",
      `<p>Are you sure you want to delete this job?</p>
    <p>After deletion, you will no longer be able to access this job.</p>`
    ).then(async (resp) => {
      if (resp) {
        try {
          const response = await DeleteJobApi(jobId);
          getDashboard();
          showSuccess(response?.message);
        } catch (err: any) {
          showError(err?.message);
        } finally {
          // setLoading(false);
        }
      }
    });
  };

  const handleViewAllApplicants = (jobId: string) => {
    NavigateTo(AppRoute.EMPLOYER_APPLICANTS, false, { jobId: jobId });
  };

  return (
    <>
      <div className="main">
        <section className="profileJoblisting-area">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 sidebar position-relative p-0">
                <EmployerSidebarScreen />
              </div>
              <div className="col-lg-10 rightcontent p-0">
                <EmployerHeaderScreen />
                {isLoading ? (
                  <Loader />
                ) : (
                  <div className="profileJoblisting-holder rightInnerScroll">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="applied-title">
                          <div className="title">
                            <h2>Overview</h2>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="overviewCard">
                          <div className="overviewCardholder">
                            <div className="iconbox">
                              <SlBriefcase />
                            </div>
                            <h2 className="redtext">
                              {dashboardDetails?.totalJobs || 0}
                            </h2>
                          </div>
                          <h4>Total Applied Jobs</h4>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="overviewCard">
                          <div className="overviewCardholder">
                            <div className="iconbox">
                              <RiCalendarScheduleLine />
                            </div>
                            <h2 className="redtext">
                              {dashboardDetails?.activeJobs || 0}
                            </h2>
                          </div>
                          <h4>Active Jobs</h4>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="overviewCard">
                          <div className="overviewCardholder">
                            <div className="iconbox">
                              <BsHourglassSplit />
                            </div>
                            <h2 className="redtext">
                              {dashboardDetails?.totalHired || 0}
                            </h2>
                          </div>
                          <h4>Hired</h4>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className={
                          messageList && messageList.length > 0
                            ? "col-lg-9"
                            : "col-lg-12"
                        }
                      >
                        <div className="title">
                          <h2>Recent Job Post</h2>
                        </div>
                        <div className="appliedJobsTable recentjobpost">
                          <div className="table-responsive">
                            <DataTable
                              data={recentPostJobsTableData}
                              columns={columns}
                              isShowPagination={false}
                            />
                          </div>
                        </div>
                      </div>
                      {messageList && messageList?.length > 0 && (
                        <div className="col-lg-3 msshld">
                          <div className="title">
                            <h2>Message</h2>
                          </div>
                          <MessageList
                            messageList={messageList}
                            chatHistory={chatHistory}
                            type="dashboard"
                            user={user}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />

      {/* View job */}
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="findajobmodal"
        centered
      >
        <button
          type="button"
          className="btn-close custom-close-btn"
          onClick={handleClose}
          aria-label="Close"
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            zIndex: 9,

            border: "none",
            fontSize: "1rem",
            cursor: "pointer",
          }}
        ></button>
        <Modal.Body>
          {selectedJob ? (
            <div className="afterapplied">
              <div className="aplyinfo">
                <div className="d-flex flex-btn  justify-content-lg-between">
                  <h4>
                    <strong>Job Title:</strong> {selectedJob?.job?.title}
                  </h4>
                  <div className="status gray first-capital">
                    {selectedJob?.job?.admin_status === "approved"
                      ? selectedJob?.job?.status
                      : selectedJob?.job?.admin_status}
                  </div>
                </div>
                <h4>
                  <strong>Category:</strong>{" "}
                  {selectedJob?.job?.category?.categoryName}
                </h4>
                <h4>
                  <strong>Type:</strong> {selectedJob?.job?.type?.typeName}
                </h4>
                <h4>
                  <strong>Applicants:</strong> {selectedJob?.Count}
                </h4>
                <h4>
                  <strong>Post Date:</strong>{" "}
                  {new Date(selectedJob?.createdAt).toLocaleDateString(
                    "en-US",
                    {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    }
                  )}
                </h4>
                <h4>
                  <strong>Expire Date:</strong>{" "}
                  {new Date(selectedJob?.job?.deadlineDate).toLocaleDateString(
                    "en-US",
                    {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    }
                  )}
                </h4>
                <div className="flex-btn d-flex">
                  <Button
                    className="btn w-50 btn-black"
                    variant="primary"
                    onClick={() => {
                      handleDelete(selectedJob?.job?.id);
                      handleClose();
                    }}
                  >
                    Delete Job Post
                  </Button>
                  <Button
                    className="btn w-50"
                    variant="primary"
                    onClick={() =>
                      handleViewAllApplicants(selectedJob?.job?.id)
                    }
                  >
                    View All Applicants
                  </Button>
                </div>
              </div>
            </div>
          ) : (
            <p>No job details available</p>
          )}
        </Modal.Body>
      </Modal>
      {/* View job ends*/}
    </>
  );
};
export default EMPDashboardScreen;
